import React, { useState } from 'react'
import { PageTitle } from '../../../../_metronic/layout/core'
import { RecordsKeeperAIBreadCrumbs } from '../core/_constants'
import { useIntl } from 'react-intl'
import RectangularTabs from '../../widgets/components/RectangularTabs'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
import { AccessLogsTable } from '../components/AccessLogsTable'
import { ActivityLogsTable } from '../components/ActivityLogsTable'

const AuditsAndLogs = () => {
    const { formatMessage } = useIntl()

    const options = [
        {
            id: 1,
            slug: 'Access-Logs',
            title: formatMessage({ id: 'Access Logs' }),
            subTitle: formatMessage({ id: 'Access Logs' }),
        },
        {
            id: 2,
            slug: 'Activity-Logs',
            title: formatMessage({ id: 'Activity Logs' }),
            subTitle: formatMessage({ id: 'Activity Logs' }),
        },
    ]

    const [selectedTab, setSelectedTab] = useState<number>(1)

    const handleTabChange = (id: number) => {
        setSelectedTab(id)
    }

    return (
        <div>
            <PageTitle
                breadcrumbs={RecordsKeeperAIBreadCrumbs}
                description={formatMessage({ id: 'Audits & Logs' })}
            >
                {formatMessage({ id: 'RecordsKeeper AI' })}
            </PageTitle>
            <div className='px-6'>
                <RectangularTabs
                    options={options}
                    selectedTab={selectedTab}
                    handleTabChange={handleTabChange}
                />
                <div className='mt-4'>
                    <InfoCard2 title={'Monitoring Access & Activity Logs'} desc={'This page provides a detailed view of access and activity logs for your records. Track who accessed or modified files, along with timestamps and location data. Use filters to find specific actions or events for auditing purposes and ensure compliance with organizational policies.'} slug={'#'} />
                </div>
                <div className='my-auto w-100 mt-4 mt-md-4'>
                    {selectedTab === 1 &&
                        <AccessLogsTable />
                    }

                    {selectedTab === 2 &&
                        <ActivityLogsTable />
                    }
                </div>
            </div>
        </div>
    )
}

export default AuditsAndLogs
